import { render, staticRenderFns } from "./App.vue?vue&type=template&id=86243638&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "normalize.css?vue&type=style&index=0&lang=css&"
import style1 from "./styles/global.sass?vue&type=style&index=1&lang=sass&"
import style2 from "./App.vue?vue&type=style&index=2&id=86243638&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86243638",
  null
  
)

export default component.exports